module.exports = __webpack_public_path__ + "static/2-fb0417e92b76f478f6375a0093d2c297.jpeg";